export const adminStyles = {
    page: {
        minHeight: "100vh",
        background: "linear-gradient(135deg, #fff7f0 0%, #f7efe6 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1.25rem",
        boxSizing: "border-box",
    },

    card: {
        width: "100%",
        maxWidth: "440px",
        backgroundColor: "#fff",
        borderRadius: "24px",
        boxShadow: "0 20px 60px rgba(0, 0, 0, 0.12)",
        padding: "clamp(1.5rem, 5vw, 2.5rem)",
        boxSizing: "border-box",
    },

    dashboardPage: {
        minHeight: "100vh",
        backgroundColor: "#faf7f3",
        padding: "clamp(1rem, 4vw, 2rem)",
        boxSizing: "border-box",
    },

    dashboardContainer: {
        width: "100%",
        maxWidth: "1100px",
        margin: "0 auto",
    },

    dashboardHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
        marginBottom: "2rem",
        flexWrap: "wrap",
    },

    title: {
        margin: 0,
        fontSize: "clamp(1.8rem, 5vw, 2.5rem)",
        lineHeight: 1.2,
    },

    subtitle: {
        margin: "0.75rem 0 0",
        color: "#666",
        lineHeight: 1.6,
    },

    label: {
        display: "block",
        marginBottom: "0.45rem",
        fontWeight: 600,
        color: "#333",
    },

    input: {
        width: "100%",
        padding: "0.95rem 1rem",
        borderRadius: "14px",
        border: "1px solid #ddd",
        fontSize: "1rem",
        boxSizing: "border-box",
        outline: "none",
    },

    field: {
        marginBottom: "1rem",
    },

    button: {
        width: "100%",
        border: "none",
        borderRadius: "999px",
        padding: "0.95rem 1.4rem",
        fontSize: "1rem",
        fontWeight: 700,
        color: "#fff",
        cursor: "pointer",
        transition: "0.2s ease",
    },

    secondaryButton: {
        border: "none",
        borderRadius: "999px",
        padding: "0.85rem 1.25rem",
        fontSize: "0.95rem",
        fontWeight: 700,
        color: "#fff",
        cursor: "pointer",
    },

    error: {
        backgroundColor: "#fff0f0",
        color: "#a40000",
        borderRadius: "12px",
        padding: "0.85rem 1rem",
        marginBottom: "1rem",
        lineHeight: 1.5,
    },

    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 260px), 1fr))",
        gap: "1.25rem",
    },

    dashboardCard: {
        backgroundColor: "#fff",
        borderRadius: "22px",
        padding: "1.5rem",
        boxShadow: "0 12px 35px rgba(0, 0, 0, 0.07)",
    },
};